// Custom CSV generator to avoid papaparse bundling issues
const convertToCsv = (data: any[]): string => {
  if (!data || data.length === 0) return '';

  // Collect union of all keys across rows to handle heterogeneous objects
  const headerSet = new Set<string>();
  data.forEach((row) => {
    if (row && typeof row === 'object') {
      Object.keys(row).forEach((key) => headerSet.add(key));
    }
  });
  const headers = Array.from(headerSet);
  const csvRows = [];

  // Add headers
  csvRows.push(headers.map((h) => `"${h}"`).join(','));

  // Add data rows
  data.forEach((row) => {
    const values = headers.map((header) => {
      const value = row[header];
      // Handle null/undefined
      if (value === null || value === undefined) return '""';
      // Escape quotes and newline characters, then wrap in quotes
      const escaped = String(value).replace(/"/g, '""').replace(/\n/g, '\\n').replace(/\r/g, '\\r');
      return `"${escaped}"`;
    });
    csvRows.push(values.join(','));
  });

  return csvRows.join('\n');
};

const convertArrayOfObjectsToCsv = (data: any[], columnMapping: { label: string; key: string }[]) => {
  const csvData = data.map((item) => {
    const csvRow: any = {};
    columnMapping.forEach((column) => {
      const keys = column.key.split('.');
      let value = item;
      keys.forEach((key) => {
        if (Array.isArray(value)) {
          value = value.map((v: any) => v[key]).join(', ');
        } else {
          value = value?.[key];
        }
      });
      csvRow[column.label] = value;
    });
    return csvRow;
  });

  const csvString = convertToCsv(csvData);
  return csvString;
};

export { convertArrayOfObjectsToCsv };
export default convertArrayOfObjectsToCsv;
